export default "__VITE_ASSET__B$rhQNez__"